import React from 'react';

const CompanyPage = () => {
	return (
		<div>
			<h1>Coming soon</h1>
		</div>
	);
};

export default CompanyPage;
